import { CategoryTag, DocumentTypeTag } from '@/data/entities'
import { DocumentTypeBadge } from './ui/badge'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from './ui/select'

export function TypeTagSelector({
  defaultValue,
  value,
  onValueChange,
}: {
  defaultValue: DocumentTypeTag
  value: DocumentTypeTag
  onValueChange: (value: DocumentTypeTag) => void
}) {
  return (
    <Select
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
    >
      <SelectTrigger className="w-full" id="select-project">
        <SelectValue placeholder="Select a tag" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Tags</SelectLabel>
          {Object.values(DocumentTypeTag).map((tag) => (
            <SelectItem value={tag} key={tag}>
              <DocumentTypeBadge type={tag as DocumentTypeTag} />
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export function CategoryTagSelector({
  defaultValue,
  value,
  onValueChange,
}: {
  defaultValue: CategoryTag
  value: CategoryTag
  onValueChange: (value: CategoryTag) => void
}) {
  return (
    <Select
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
    >
      <SelectTrigger className="w-full" id="select-project">
        <SelectValue placeholder="Select a tag" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Tags</SelectLabel>
          {Object.values(CategoryTag).map((tag) => (
            <SelectItem value={tag} key={tag}>
              {tag}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
